import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PageLoadingBar from "../../components/scrollbar/pageLoadingBar";
import Homepage from "../HomePage/HomePage";
const AboutPage = lazy(() => import("../AboutPage/AboutPage"));
const FaqPage = lazy(() => import("../FaqPage/FaqPage"));
const ServicePages = lazy(() => import("../ServicePage/ServicePage"));
const SubcategoryPage = lazy(() => import("../SubcategoryPage/SubcategoryPage"));
const ServiceSinglePage = lazy(() =>
  import("../ServiceSinglePage/ServiceSinglePage")
);
const ContactPage = lazy(() => import("../ContactPage/ContactPage"));
const ErrorPage = lazy(() => import("../ErrorPage/ErrorPage"));
const PrivacyPolicyPage = lazy(() =>
  import("../PrivacyPolicyPage/PrivacyPolicy")
);
const TermsConditionsPage = lazy(() =>
  import("../TermsConditionsPage/TermsConditions")
);

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
      <PageLoadingBar />
        {/* Suspense wrapper shows fallback while pages load */}
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="home" element={<Homepage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="faq" element={<FaqPage />} />
            <Route path="products" element={<ServicePages />} />
            <Route path="product/:subcategory" element={<SubcategoryPage />} />
            <Route path="product/:subcategory/:code" element={<ServiceSinglePage />} />
            <Route path="product/:subcategory/:code/:color" element={<ServiceSinglePage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="404" element={<ErrorPage />} />
            <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
            <Route
              path="terms-and-conditions"
              element={<TermsConditionsPage />}
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
